/**
 * Language and text direction of a page, from its path. Used for the
 * published page's <html lang dir> and by the page editor, so both agree.
 *
 * ff.com: /cn is Chinese, /ar is Arabic (right to left) except /ar/en, and
 * /ae_ar is Arabic. ffai.com mirrors that under /ffai: /ffai/cn is Chinese,
 * /ffai/ar is Arabic except /ffai/ar/en. Everything else is US English.
 */
const isUnder = (path, prefix) => path === prefix || path.startsWith(`${prefix}/`);

export default function getPageLangDir(path) {
  const p = path || '';

  if (p.startsWith('/cn') || p.startsWith('/ffai/cn')) return { lang: 'zh-cn', dir: 'ltr' };
  if (isUnder(p, '/ffai/ar/en')) return { lang: 'en', dir: 'ltr' };
  if (isUnder(p, '/ffai/ar')) return { lang: 'ar', dir: 'rtl' };
  if (p.startsWith('/ar/en')) return { lang: 'en', dir: 'ltr' };
  if (p.startsWith('/ar')) return { lang: 'ar', dir: 'rtl' };
  if (p.startsWith('/ae_ar')) return { lang: 'ar', dir: 'rtl' };
  return { lang: 'en-US', dir: 'ltr' };
}
